const initialState = {
  activities: [],
};

const ClientActivities = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CLIENT_ACTIVITIES':
      return { ...state, activities: action.payload };
    case 'ADD_CLIENT_ACTIVITY':
      return { ...state, activities: [action.payload, ...state.activities] };
    default:
      return state;
  }
};

export default ClientActivities;
